// getFirstDayOfQuarter will return a Date with first day of the quarter for the input Date
// if the input month is in Q1, the function will return the first day of Q1
// with option "last = true" function will return the last day of the quarter.

export function getFirstDayOfQuarter(date: Date, last?: boolean): Date {
	const year = date.getFullYear()
	const month = date.getMonth()
	let hours = date.getHours()
	let startMonth: number

	let day: number
	day = 1

	if (last === true) {
		day = 0
		hours = 0
	}

	if (month < 3) {
		startMonth = 0
	} else if (month < 6) {
		startMonth = 3
	} else if (month < 9) {
		startMonth = 6
	} else {
		startMonth = 9
	}

	return new Date(year, startMonth, 1, hours)
}
